import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

import { Button } from 'common/materials';

import TicketLegacyView from './v1/TicketLegacy.view';
import TicketV2View from './v2/TicketV2.view';

type TicketVersion = 'v1' | 'v2';

const V2_SYSTEM_IDS = new Set(['STD', 'DEV']);

export function resolveTicketVersion(systemId: string): TicketVersion {
    return V2_SYSTEM_IDS.has(systemId.trim().toUpperCase()) ? 'v2' : 'v1';
}

function TicketView() {
    const [version, setVersion] = useState<TicketVersion>();
    const [error, setError] = useState('');

    const loadVersion = useCallback(async () => {
        setVersion(undefined);
        setError('');

        try {
            const response = await axios.get<{ link_sid?: string }>('/v1/link-sid');
            const systemId = response.data.link_sid;
            if (!systemId?.trim()) throw new Error('ไม่พบ System ID');

            setVersion(resolveTicketVersion(systemId));
        } catch (loadError) {
            setError((loadError as Error).message || 'ไม่สามารถตรวจสอบระบบ Ticket ได้');
        }
    }, []);

    useEffect(() => {
        void loadVersion();
    }, [loadVersion]);

    if (error) {
        return (
            <div className="flex min-h-[240px] flex-col items-center justify-center gap-3">
                <p className="text-sm text-danger-600">{error}</p>
                <Button
                    outline
                    onClick={loadVersion}
                >
                    ลองใหม่
                </Button>
            </div>
        );
    }

    if (!version) {
        return <div className="py-10 text-center text-sm text-neutral-500">กำลังโหลด Ticket...</div>;
    }

    return version === 'v2' ? <TicketV2View /> : <TicketLegacyView />;
}

export default TicketView;
